import { create } from 'zustand';

interface ConvertingPageState {
  previousPath: string;
  setPreviousPath: (path: string) => void;
}

const useConvertingPageStore = create<ConvertingPageState>(set => ({
  previousPath: '',
  setPreviousPath: path => set({ previousPath: path }),
}));

export default useConvertingPageStore;
